import React from 'react';
import { Header } from '../../row/header';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AheadPreview from '../../ahead/ahead-preview';
import { setPageType } from '../../actions/builder-action';
import { getPageType } from '../../utils/utils';

const ManageSubscriptions = () => {
  const { publisherId = '' } = useParams();
  const dispatch = useDispatch();
  const pageType = getPageType();

  dispatch(setPageType(pageType));
  return (
    <>
      <Header publisherId={publisherId} />
      <AheadPreview />
    </>
  );
};

export default ManageSubscriptions;
